<template>
  <div class="fullHeight">
    <mu-row>
      <mu-col desktop="30" tablet="25"></mu-col>
      <mu-col desktop="40" tablet="50" class="animated fadeInUp">
        <mu-card-text>
          <mu-card>
            <mu-card-header :title="$t('message.labelModifyDetails')"
                            titleClass="largeTitle blueTitle"></mu-card-header>
            <mu-card-text>
              <p v-if="!$route.query.hcp">{{$t('message.modifySubTitle')}}</p>
              <p v-if="$route.query.hcp">Join the free Healthcare Professional Platform</p>
              <form v-on:submit.prevent="submitForm">
                <mu-text-field
                  id="firstnameTxt"
                  style="margin-bottom: -8px"
                  v-validate="{required:true, max:40, regex: /^[a-zA-Z ]*$/}"
                  data-vv-name="first_name"
                  data-vv-value-path="inputValue"
                  data-vv-validate-on="none"
                  :data-vv-as="$t('message.accountPreferencesFirstName')"
                  :errorText="errors.first('first_name')"
                  :label="$t('message.labelYourName')"
                  type="text"
                  v-model="model.firstname"
                  :hintText="$t('message.accountPreferencesFirstName')"
                  fullWidth>
                </mu-text-field>

                <mu-text-field
                  id="surnameTxt"
                  v-validate="{required:true, max:40, regex: /^[a-zA-Z ]*$/}"
                  data-vv-name="last_name"
                  data-vv-value-path="inputValue"
                  data-vv-validate-on="none"
                  :data-vv-as="$t('message.accountPreferencesSurname')"
                  :errorText="errors.first('last_name')"
                  type="text"
                  v-model="model.surname"
                  :hintText="$t('message.accountPreferencesSurname')"
                  fullWidth>
                </mu-text-field>

                <mu-text-field
                  id="emailTxt"
                  :data-vv-as="$t('message.accountPreferencesEmail')"
                  :label="$t('message.accountPreferencesEmail')"
                  type="email"
                  v-model="model.email"
                  :hintText="$t('message.placeholderEmail')"
                  fullWidth
                  :disabled="true"
                ></mu-text-field>

                <mu-text-field
                  id="emailTxtV"
                  :data-vv-as="$t('message.accountPreferencesEmailVerify')"
                  :label="$t('message.accountPreferencesEmailVerify')"
                  type="email"
                  v-model="model.email"
                  :hintText="$t('message.placeholderEmail')"
                  fullWidth
                  :disabled="true"
                ></mu-text-field>

<!--                <div class="field">-->
<!--                  <mu-text-field-->
<!--                    id="passwordTxt"-->
<!--                    :type="'password'"-->
<!--                    :label="$t('message.accountPreferencesPassword')"-->
<!--                    v-model="dummyPassword"-->
<!--                    :hintText="$t('message.accountPreferencesPassword')"-->
<!--                    :errorText="errors.first('password')"-->
<!--                    :disabled="true"-->
<!--                    fullWidth>-->
<!--                  </mu-text-field>-->
<!--                  <mu-icon-button-->
<!--                    class="right-icon"-->
<!--                    :icon="'visibility'"-->
<!--                    :disabled="true"-->
<!--                  ></mu-icon-button>-->
<!--                </div>-->

<!--                <div class="field">-->
<!--                  <mu-text-field-->
<!--                    id="passwordTxtV"-->
<!--                    :type="'password'"-->
<!--                    :label="$t('message.accountPreferencesPasswordVerify')"-->
<!--                    v-model="dummyPassword"-->
<!--                    :hintText="$t('message.accountPreferencesPasswordVerify')"-->
<!--                    :errorText="errors.first('passwordVerify')"-->
<!--                    fullWidth-->
<!--                    :disabled="true"-->
<!--                  >-->
<!--                  </mu-text-field>-->
<!--                  <mu-icon-button-->
<!--                    class="right-icon"-->
<!--                    :icon="'visibility'"-->
<!--                    :disabled="true"-->
<!--                  ></mu-icon-button>-->
<!--                </div>-->


                <div class="mu-text-field-label">
                  Date of birth
                </div>

                <mu-row>
                  <mu-col desktop="33" tablet="33" width="33">
                    <select
                      name="birth_day"
                      v-validate
                      :class="{'error': errors.first('birth_day')}"
                      :data-vv-rules="'required'"
                      data-vv-name="birth_day"
                      data-vv-as="day"
                      v-model="dob.day" class="native-select"
                    >
                      <option :value="null">Day</option>
                      <option
                        v-for="(day, index) in dobItems.days"
                        :key="'day-' + index"
                        :value="day"
                      >{{day}}
                      </option>
                    </select>
                  </mu-col>
                  <mu-col desktop="33" tablet="33" width="33">
                    <select
                      name="birth_month"
                      v-validate
                      :class="{'error': errors.first('birth_month')}"
                      :data-vv-rules="'required'"
                      data-vv-name="birth_month"
                      data-vv-as="month"
                      v-model="dob.month" class="native-select">
                      <option :value="null">Month</option>
                      <option
                        v-for="(month, index) in dobItems.months"
                        v-once
                        :key="'month-' + index"
                        :value="month"
                      >{{localizeMonth(month.name)}}
                      </option>
                    </select>
                  </mu-col>
                  <mu-col desktop="33" tablet="33" width="33">
                    <select
                      name="birth_year"
                      v-validate
                      :class="{'error': errors.first('birth_year')}"
                      :data-vv-rules="'required'"
                      data-vv-name="birth_year"
                      data-vv-as="year"
                      v-model="dob.year"
                      class="native-select">
                      <option :value="null">Year</option>
                      <option
                        v-for="(year, index) in dobItems.years"
                        v-once
                        :key="'year-' + index"
                        :value="year"
                      >{{year.value}}
                      </option>
                    </select>
                  </mu-col>
                </mu-row>

                <p class="privacyDisclaimer" @click="setTerms">
                  <mu-checkbox v-model="terms">
                  </mu-checkbox>
                  {{$t('message.registerTermsByContinuing')}}
                  <a :href="`${siteUrl}terms`" target="_blank">{{$t('message.registerTermsAndCondtions')}}</a>
                  {{$t('message.registerTermsJoin')}} <a :href="`${siteUrl}privacy`" target="_blank">{{$t('message.registerPrivacyPolicy')}}</a>,
                  <a :href="`${siteUrl}cookies`" target="_blank">{{$t('message.registerIncludingCookie')}}</a>
                </p>

                <button type="submit" style="display: none;"></button>

                <mu-raised-button
                  id="submitBtn"
                  @click.native="submitForm()"
                  type="button"
                  :label="isSaving ? $t('message.labelProcessing') : $t('message.amendAppBarText')"
                  :disabled="isSaving"
                  secondary
                  fullWidth
                ></mu-raised-button>
              </form>
              <transition name="fade">
                <alert type="danger" icon="error" v-if="isError" style="margin-top: 16px; margin-bottom: 0px;">
                  <div slot="content">
                    {{ $t('message.registerErrorUserExists') }}
                  </div>
                </alert>
                <alert type="danger" icon="error" v-if="isTermsError" style="margin-top: 16px; margin-bottom: 0px;">
                  <div slot="content">
                    Please agree to our terms and conditions
                  </div>
                </alert>
                <alert type="danger" icon="error" v-if="isServerValidationError"
                       style="margin-top: 16px; margin-bottom: 0px;">
                  <div slot="content">
                    {{serverValidationErrorText}}
                  </div>
                </alert>
              </transition>
            </mu-card-text>
          </mu-card>
        </mu-card-text>
      </mu-col>
      <mu-col desktop="30" tablet="25"></mu-col>
    </mu-row>
  </div>
</template>

<script>
  import {Objects} from '../../helpers/Utilities'

  const DobObject = Objects.DobObject;

  import RegistrationApi from '../../api/Registration'
  import UserApi from '../../api/User'
  import Alert from "../../components/Alert/Alert";
  import Config from '../../config';
  import MonthLocalizerMixin from '../../mixins/Localization/DateMonths'
  import AccountApi from "../../api/Account";

  export default {
    mixins: [MonthLocalizerMixin],
    components: {Alert},
    data() {
      return {
        siteUrl: Config.siteUrl,
        isError: false,
        isSaving: false,
        terms: true,
        isTermsError: false,
        isServerValidationError: false,
        serverValidationErrorText: false,
        dobItems: DobObject,
        dummyPassword: Math.random().toString(36)
          .replace(/[^a-z]+/g, '')
          .substr(0, Math.floor(Math.random() * (16 - 8 + 1)) + 8),
        model: {
          firstname: null,
          surname: null,
          dob: null,
        },
        dob: {
          day: null,
          month: null,
          year: null
        }
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/register/amend');

      AccountApi.getAccount()
        .then(function (response) {
          self.model = response.data;
          if (self.model.dob !== null) {
            let dob = self.model.dob.split('-');
            self.dob.year = self.dobItems.years.find(year => year.value === dob[0]);
            self.dob.month = self.dobItems.months.find(month => month.value === dob[1]);
            self.dob.day = dob[2];
          }
          self.isLoading = false;
        });
    },
    computed: {
      isAmendAgeValid: function() {
        if (this.dob.day && this.dob.month && this.dob.year) {
          let userDob = `${this.dob.year.value}-${this.dob.month.value}-${this.dob.day}`;
          let dob = moment(userDob);
          let ageRestrict = moment().subtract(18, 'years');
          let validAge = moment(dob).isBefore(ageRestrict);
          return validAge;
        }
      },
      isOlderThan100: function() {
        if (this.dob.day && this.dob.month && this.dob.year) {
          let userDob = `${this.dob.year.value}-${this.dob.month.value}-${this.dob.day}`;
          let dob = moment(userDob);
          let ageRestrict = moment().subtract(100, 'years');
          let validAge = moment(dob).isBefore(ageRestrict);
          return validAge;
        }
      }
    },
    watch: {
      'dob.day': function () {
        let self = this;
        self.formatDateOfBirth();
        self.isServerValidationError = false;
      },
      'dob.month': function () {
        let self = this;
        self.updateValidDobMonthDays();
        self.formatDateOfBirth();
        self.isServerValidationError = false;
      },
      'dob.year': function () {
        let self = this;
        self.updateValidDobMonthDays();
        self.formatDateOfBirth();
        self.isServerValidationError = false;
      }
    },
    methods: {
      formatDateOfBirth() {
        let self = this;
        if ((!_.isNull(self.dob.day)) && (!_.isNull(self.dob.month)) && (!_.isNull(self.dob.year))) {
          self.model.dob = self.dob.year.value + '-' + self.dob.month.value + '-' + self.dob.day
        }
      },
      updateValidDobMonthDays() {
        let self = this;
        if (!self.dob.month || !self.dob.month.daysCount) {
          return;
        }

        let days = self.dob.month.daysCount + 1;

        if (!_.isNull(self.dob.year) && self.dob.year.isLeap === true && self.dob.month.value === "02") {
          days = self.dob.month.daysCount + 2;
        }

        let daysArray = [];

        for (let i = 1; i < days; i++) {
          if (i < 10) {
            daysArray.push('0' + i + '')
          } else {
            daysArray.push('' + i + '')
          }
        }

        self.$set(self.dobItems, 'days', daysArray);
      },
      setTerms() {
        let self = this;
        self.terms = !self.terms;
        self.isTermsError = false;
      },
      submitForm() {
        let self = this;

        if (self.isOlderThan100 === true) {
          self.$toastr.error("You have to be under 100 to sign up");
          return;
        }

        if (!self.terms) {
          self.isTermsError = true;
          return;
        }

        //Verifies User Credentials
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid && self.isAmendAgeValid) {
              let registrationModel = {
                firstname: self.model.firstname,
                surname: self.model.surname,
                dob: self.model.dob
              };

              self.isSaving = true;
              RegistrationApi.amend(registrationModel)
                .then(function (response) {

                  self.$router.push({
                    name: 'Subscription'
                  });

                })
                .catch(function (error) {
                  self.isSaving = false;

                  if (error.response.status === 500) {

                    self.isError = true;
                    self.$gtag.event('RegistrationError',{
                      'event_category': 'Registration Amend',
                      'event_label': 'Error Amending Details',
                      'value': 1
                    });
                  } else if (error.response.status === 422) {
                    self.isServerValidationError = true;
                    self.serverValidationErrorText = error.response.data.message;
                  }

                });
            } else if (!self.isAmendAgeValid) {
              self.$toastr.error("You have to be 18 or over to sign up");
            }
          });
      }
    }
  }
</script>

<style>
  div#register {
    background-image: url('../../../static/pw/hero-image.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-position-y: -400px;
  }
</style>
<style scoped lang="less">
  .field {
    position: relative;
  }

  .field .right-icon {
    position: absolute;
    top: 20px;
    right: 0;
  }

  .noAccount {
    font-size: 16px;
    margin-bottom: 16px;
    margin-top: 16px;
    color: #9B9B9B;
  }

  .fullHeight {
    height: 100%;
    min-height: 100%;
    max-height: 100%;
  }

  .IsError {
    color: white;
    background: red;
    width: 100%;
    padding: 16px;
  }

  .privacyDisclaimer {
    position: relative;
    padding: 0 0 0 35px;

    .mu-checkbox {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// Amend.vue?3553dd75